

















































































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator';
import { Account } from '@/api/braendz';
import { BusyObject } from '@/models/Busy';

@Component({
    components: {
    }
})
export default class ProductCard extends Vue {

    // Member:
    @Prop({ required: true })
    public userAction!: 'test' | 'subscribe' | 'active' | 'upgrade' | 'downgrade' | null;

    @Prop({ required: true, type: Boolean, default: true })
    public selectable!: boolean;

    @Prop({ required: true })
    public productKey!: string;

    @Prop({ required: true })
    public name!: string;

    @Prop({ required: true })
    public subtitle!: string;

    @Prop({ required: false })
    public description?: string;

    @Prop({ required: true })
    public price!: number;

    @Prop({ required: false })
    public priceRemark?: string;

    @Prop({ required: false, default: 'card' })
    public variant?: 'card' | 'tile';

    // Getter:
    public get netPrice(): number {
        return this.price / 1.19;
    }

    public get account(): BusyObject<Account> {
        return this.$store.state.account;
    }

    // Lifecycle Methods:

}
